/* eslint-disable no-console */

enum LogLevel {
	Debug,
	Info,
	Warn,
	Error,
}

type LogLevelKey = keyof typeof LogLevel;

let logLevel: LogLevel = LogLevel.Error;
const time = Date.now();

export const setLogLevel = (newLogLevel: LogLevelKey) => (logLevel = LogLevel[newLogLevel]);

// A lot of unknown usage so we have to leave it like this...
type LogMessage = unknown; // | string | (object & { message?: string });
export const debug = (...message: LogMessage[]) => log("Debug", "Log message", ...message);
export const info = (...message: LogMessage[]) => log("Info", "Log message", ...message);
export const warn = (...message: LogMessage[]) => log("Warn", "Log message", ...message);
export const error = (...message: LogMessage[]) => log("Error", "Log message", ...message);

export const log = (type: LogLevelKey, title: string, ...message: LogMessage[]) => {
	let css = "";
	switch (type) {
		case "Info":
			css = "background: #777; color: #fff;";
			break;
		case "Warn":
			css = "background: #FF7F00; color: #fff;";
			break;
		case "Error":
			css = "background: #c00; color: #fff;";
			break;
	}

	if (LogLevel[type] < logLevel) {
		return;
	}

	let logger = console.log;

	const isWarn = LogLevel[type] === LogLevel.Warn;
	if (isWarn) {
		logger = console.warn;
	}

	logger(
		"%c " + format(Date.now() - time) + " %c " + title + " ",
		"background: #000; color: #bada55;",
		css,
		...message
	);

	const isError = LogLevel[type] === LogLevel.Error;
	if (isError) {
		const getTypeFromMessage = (message: LogMessage[]) => {
			if (typeof message[0] === "string") {
				return message[0];
			}
			if (message[0] && typeof (message[0] as { message?: string }).message === "string") {
				return (message[0] as { message: string }).message;
			}
			return message;
		};
		// Pass the original Error so error tracking reports its real stack
		// instead of a synthetic one pointing at the logger.
		const errorArg = message.find(item => item instanceof Error);
		if (errorArg) {
			console.error(errorArg);
		} else {
			console.error(getTypeFromMessage(message));
		}
	}
};

const format = (milliseconds: number): string => {
	const totalSeconds = Math.floor(milliseconds / 1000);
	let minutes = Math.floor(totalSeconds / 60.0) + "";
	while (minutes.length < 2) minutes = "0" + minutes;
	let seconds = (totalSeconds % 60) + "";
	while (seconds.length < 2) seconds = "0" + seconds;
	return minutes + ":" + seconds;
};
